webpackJsonp([29],{

/***/ 1008:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/messenger/index.js + 17 modules
var messenger = __webpack_require__(362);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/MessengerMessage.vue





/* harmony default export */ var MessengerMessage = ({
  components: {
    MessengerChat: messenger["a" /* MessengerChat */]
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    conversations: 'skiliko/conversations/collection'
  }), {
    conversation: function conversation() {
      return this.conversations[this.id];
    }
  }),
  methods: Object(vuex_esm["b" /* mapActions */])({
    fetch: 'skiliko/conversations/fetch'
  }),
  mounted: function mounted() {
    this.fetch({ id: this.id });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c0cb06","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MessengerMessage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.conversation)?_c('messenger-chat',{attrs:{"conversation":_vm.conversation}}):_c('span',[_vm._v("loading")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_MessengerMessage = (esExports);
// CONCATENATED MODULE: ./src/pages/MessengerMessage.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MessengerMessage,
  pages_MessengerMessage,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_MessengerMessage = __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/29.42cade50943e0dbefbdc.js